import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Select, message } from 'antd';
import { layout, tailLayout } from './constant';
import ApiServices from '~services';
import { Selection } from '~components';
const { Option } = Select;

const STATUS_OPTION = [
  {
    label: 'Đang làm',
    value: 0,
  },
  {
    label: 'Nghỉ việc',
    value: 1,
  },
];

const DriverForm = ({ fields, isNew, id, reload, onChange, setLoading, dataSelected }) => {
  const inputRef = useRef(null);
  const [driverType, setDriverType] = useState([]);
  const [companies, setCompanies] = useState([]);

  const getDataInit = async () => {
    const [getStaticVariable] = await Promise.all([ApiServices.getStaticVariables()]);
    setDriverType(getStaticVariable.data.DriverType);
  };

  const getCompanies = async (query = '') => {
    const newQuery = {
      Columns: {
        name: query,
      },
    };
    try {
      const res = await ApiServices.getCompanies(query ? newQuery : null);
      if (res?.data?.data) {
        setCompanies(res?.data?.data || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDataInit();
    getCompanies();
  }, []);

  const onCompareWithApi = (value, cb) => {
    if (inputRef.current) {
      clearTimeout(inputRef.current);
      cb();
    }
    inputRef.current = setTimeout(async () => {
      try {
        const { data } = await ApiServices.existsCodeDriver(null, value);
        const isUsed = data;
        cb(isUsed);
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  };

  const checkExistsCode = async (_, value) => {
    if (value.length > 3) {
      const ind = fields.findIndex((item) => {
        return item.name[0] === 'code';
      });
      if (isNew === false && value !== fields[ind].value) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Tài Xế này đã tạo rồi !!!'));
        }
      }

      if (isNew === true) {
        try {
          const waitMe = () =>
            new Promise((resolve, reject) => {
              onCompareWithApi(value, (isUsed) => {
                if (typeof isUsed !== 'undefined') {
                  if (isUsed) reject();
                  resolve();
                }
              });
            });
          await waitMe();
        } catch (error) {
          return Promise.reject(new Error('Mã Tài Xế này đã tạo rồi !!!'));
        }
      }
    }
  };

  const createDriver = async (data) => {
    try {
      const res = await ApiServices.createDriver(data);
      if (res.data) {
        message.success('Thêm mới Tài Xế thành công');
        return reload();
      } else {
        message.error('Thêm mới Tài Xế thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Thêm mới Tài Xế thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const updateDriver = async (data) => {
    data.id = id;
    try {
      const res = await ApiServices.updateDriver(id, data);
      if (res.data) {
        message.success('Cập nhật Tài Xế thành công');
        return reload();
      } else {
        message.error('Cập nhật Tài Xế thất baị, vui lòng kiểm tra lại thông tin');
      }
    } catch (err) {
      message.error('Cập nhật Tài Xế thất baị, vui lòng kiểm tra lại thông tin');
      console.error(err);
    }
  };
  const onSubmitForm = async (value) => {
    if (isNew) {
      setLoading(true);
      await createDriver(value);
      setLoading(false);
      return;
    }
    setLoading(true);
    await updateDriver(value);
    setLoading(false);
  };
  return (
    <Form
      {...layout}
      name='global_state'
      className='form-input-data'
      onFinish={onSubmitForm}
      fields={fields}
      onFieldsChange={(_, allFields) => {
        onChange(allFields);
      }}
    >
      <Form.Item
        // {...itemLayout}
        style={{ marginTop: '10px' }}
        name='code'
        label='Mã Tài Xế'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Mã Tài Xế',
          },
          {
            validator: checkExistsCode,
          },
          {
            type: 'string',
            min: 4,
            message: 'Bạn phải nhập ít nhất 4 ký tự',
          },
        ]}
      >
        <Input placeholder='Mã Tài Xế' />
      </Form.Item>

      <Form.Item
        style={{ marginTop: '10px' }}
        name='name'
        label='Tên Tài Xế'
        rules={[
          {
            required: true,
            message: 'bạn phải nhập Tên Tài Xế',
          },
        ]}
      >
        <Input placeholder='Tên Tài Xế' />
      </Form.Item>
      <Form.Item
        name='companyId'
        label='Công Ty'
        rules={[
          {
            required: true,
            message: 'Bạn phải chọn Công Ty',
          },
        ]}
      >
        <Selection
          labelDefault={dataSelected?.companyName || ''}
          data={companies}
          placeholder='Bạn phải chọn Công Ty'
          fieldValue='name'
          onSearch={getCompanies}
        />
      </Form.Item>
      <Form.Item
        name='salary'
        label='Lương'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Lương TX',
          },
        ]}
      >
        <Input placeholder='Lương TX' type='number' />
      </Form.Item>
      <Form.Item
        name='phone'
        label='Số Điện thoại'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Số Điện thoại',
          },
        ]}
      >
        <Input placeholder='Số Điện thoại' type='number' />
      </Form.Item>
      <Form.Item
        name='typeDriver'
        label='Nhóm tài xế'
        rules={[
          {
            required: true,
            message: 'Bạn phải nhập Nhóm tài xế',
          },
        ]}
      >
        <Select showSearch placeholder='Nhóm tài xế'>
          {Object.keys(driverType).map((item, index) => (
            <Option key={index} value={driverType[item]}>
              {driverType[item]}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name='email' label='Email'>
        <Input placeholder='Email' />
      </Form.Item>
      <Form.Item name='idCard' label='CCCD'>
        <Input placeholder='CCCD' />
      </Form.Item>
      {!isNew && (
        <Form.Item name='status' label='Trạng thái'>
          <Select showSearch placeholder='Trạng thái'>
            {STATUS_OPTION.map((item, index) => (
              <Option key={item.label + index} value={item.value}>
                {item.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      )}

      <Form.Item {...tailLayout} className='submit-form-input-data'>
        <Button type='primary' htmlType='submit'>
          {isNew ? 'Thêm Mới' : 'Cập nhật'}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { DriverForm };
